import * as Yup from "yup";

export const BaseOrderSchema = Yup.object().shape({
    user_id: Yup.number()
        .transform((value) => (isNaN(value) ? undefined : value))
        .required("Пожалуйста, укажите пользователя"),
    cart_number: Yup.string().required("Пожалуйста, укажите идентификатор корзины"),
});
